import { useMemo } from 'react';
import { useMutation, MutationOptions } from 'react-query';
import HouseholdService from '../../services/householdService';
import useAbortController from '../useAbortController';

const useChangeHeadOfHouseholdMutation = ({
  organizationId,
  propertyId,
  householdId,
  options,
}: {
  organizationId: string,
  propertyId: string,
  householdId: string,
  options?: MutationOptions,
}) => {
  const householdService = useMemo(() => new HouseholdService(), []);
  const abortControllerOptions = useAbortController();

  return useMutation(
    (payload) =>
      householdService.changeHeadOfHousehold(
        organizationId,
        propertyId,
        householdId,
        payload,
        abortControllerOptions,
      ),
    options,
  );
};

export default useChangeHeadOfHouseholdMutation;
